import TextField from "@material-ui/core/TextField/TextField";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import ArrowUp from "@material-ui/icons/ArrowDropDown";
import ArrowDown from "@material-ui/icons/ArrowDropUp";
import React from "react";
import * as Logger from "./Logger";

function NumericField(props) {
    const [value, setValue] = React.useState(1);

    if (props.value && value && props.value != value) {
        setValue(parseInt(props.value));
    }

    function handleUp() {
        if (props.onChange) {
            Logger.log("onChange")
            props.onChange({
                target :{
                    value : value+1,
                }
            });
        }
    }

    function handleDown() {

        if (props.onChange) {
            Logger.log("onChange")
            props.onChange({
                target :{
                    value : value-1,
                }
            });
        }
    }

    function handleChange(event) {
        const {value} = event.target;
        setValue(value);
        if (props.onChange) {
            Logger.log("onChange")
            props.onChange(event);
        }
    }

    return <TextField {...props}
                      onChange={handleChange}
                      input
                      style={{margin:0,width:"100%"}}
                      value={value}
                      InputProps={{
                          endAdornment: (
                              <InputAdornment position="end">
                                  <IconButton aria-label="Increment" onClick={handleDown}>
                                      <ArrowUp/>
                                  </IconButton>
                                  <IconButton aria-label="Decrement" onClick={handleUp}>
                                      <ArrowDown/>
                                  </IconButton>
                              </InputAdornment>
                          ),
                      }}/>;
}

export default NumericField;
